const TimeOfDayDetailsDiscount = () => {
  return {
    name: 'Schedule R-TOD',
    title: 'Residential Service (Experimental)',
    rateElements: [
      // Fixed Monthly Charge
      {
        rateElementType: 'FixedPerMonth',
        name: 'Basic Customer Charge',
        rateComponents: [
          {
            charge: 25.5,
            name: 'Basic Customer Charge',
          },
        ],
      },
      // Energy Charges for Distribution kWh
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution kWh Charge - Summer',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.3557, // 35.5700¢ per kWh
            months: [5, 6, 7, 8], // June - September
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [17, 18, 19, 20], // 17:00 - 20:00
            name: 'Summer On-Peak kWh Charge',
          },
          {
            charge: 0.2021, // 20.2100¢ per kWh
            months: [5, 6, 7, 8], // June - September
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [12, 13, 14, 15, 16, 21, 22, 23], // 12:00-16:00, 21:00-23:00
            name: 'Summer Mid-Peak kWh Charge',
          },
          {
            charge: 0.1464, // 14.6400¢ per kWh
            months: [5, 6, 7, 8], // June - September
            daysOfWeek: [1, 2, 3, 4, 5], // Mon - Fri
            hourStarts: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // 00:00-11:00
            name: 'Summer Off-Peak kWh Charge',
          },
          {
            charge: 0.1464, // 14.6400¢ per kWh
            months: [5, 6, 7, 8], // June - September
            daysOfWeek: [0, 6], // Sun and Sat
            hourStarts: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // 00:00-11:00
            name: 'Summer Off-Peak kWh Charge',
          },
          {
            charge: -0.015, // 1.5000¢ per kWh
            months: [5, 6, 7, 8], // June - September... it starts with 0
            daysOfWeek: [0, 1, 2, 3, 4, 5, 6], // All Days
            hourStarts: [0, 1, 2, 3, 4, 5, 6], //00:00 - 06:00
            name: 'summer discount',
          },
        ],
      },
      {
        rateElementType: 'EnergyTimeOfUse',
        name: 'Distribution kWh Charge - Winter',
        classification: 'energy',
        billingCategory: 'delivery',
        rateComponents: [
          {
            charge: 0.1633, // 16.3300¢ per kWh
            months: [0, 1, 2, 3, 4, 9, 10, 11], // January - May and October - December
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [17, 18, 19, 20], // 17:00-20:00
            name: 'Winter On-Peak kWh Charge',
          },
          {
            charge: 0.1215, // 12.1500¢ per kWh
            months: [0, 1, 2, 3, 4, 9, 10, 11], // January - May and October - December
            daysOfWeek: [1, 2, 3, 4, 5], // Mon-Fri
            hourStarts: [
              0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 21, 22,
              23,
            ], // 00:00 - 16:00; 21:00- 23:00
            name: 'Winter Off-Peak kWh Charge',
          },
          {
            charge: 0.1215, // 12.1500¢ per kWh
            months: [0, 1, 2, 3, 4, 9, 10, 11], // January - May and October - December
            daysOfWeek: [0, 6], // Sun and Saturday
            hourStarts: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // 00:00-11:00
            name: 'Winter Off-Peak kWh Charge',
          },
          {
            charge: -0.015, // 1.5000¢ per kWh
            months: [0, 1, 2, 3, 4, 9, 10, 11], // January - May and October - December
            daysOfWeek: [0, 1, 2, 3, 4, 5, 6], // All Days
            hourStarts: [0, 1, 2, 3, 4, 5, 6], //00:00 - 06:00
            name: 'winter discount',
          },
        ],
      },
    ],
  };
};

export default TimeOfDayDetailsDiscount;
